import React, { useState, useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useMediaQuery } from '@material-ui/core'
import {
  SimpleLoading,
  PromotionalFooterPure,
  ButtonAddHLPure,
  TooltipHLPure
} from '../../pures'
import { ClientDocument } from '../../../services'
import {
  DialogSystemGLPure,
  SearchBarHLPure,
  GridSelectionHLPure,
  DropDownBtnHLPure,
  DocumentsToRequireClassifyModal
} from '../../pures'
import './documents-to-require.css'
import DocumentsToRequireConfigurationView from './documents-to-require-pages/documents-to-require-configurations.view'
import { ArrowBtnMobile } from '../../../assets/logos/icons'
import moment from 'moment'
import { convertToStandarDate } from '../../../utils'

const HeaderColumns = (props) => {
  return <span className={(props.title === props.t('documentsToRequire.grid.documents')) ? 'grid-header-one' : 'grid-headers'}>{props.title}</span>
}

const CellColumnName = (props) => {
  return (
    <td className='manageAssemblyView-grid-col1'>
      <div className='documents-to-require-grid-cell-double-container-margin-left'>
        <p className='grid-cell-titles'>{props.dataItem.name}</p>
        <p className='grid-cell-subtitles'>{props.dataItem.newUpdatedDate}</p>
      </div>
    </td>
  )
}
const CellColumnGroup = ({ dataItem }) => {
  const groups = Array.isArray(dataItem.groups)
    ? dataItem.groups.filter(g => g.value !== false)
    : []

  const count = groups.length
  const { t } = useTranslation()

  if (count === 0) {
    return (
      <td>
        <div className="documents-to-require-grid-cell-group">
          <span>{t('documentsToRequire.grid.group.tooltip.no')}</span>
        </div>
      </td>
    )
  }

  const firstGroupName = groups[0].name
  const allGroupNames = groups.map(g => g.name).join(', ')
  return (
    <td>
      <div className="documents-to-require-grid-cell-group">
        <span>{firstGroupName}</span>

        {count > 1 && (
          <TooltipHLPure
            positionTooltip="right"
            titleTooltip={t('documentsToRequire.grid.group')}
            descriptionTooltip={allGroupNames}
            informationIcon
          />
        )}
      </div>
    </td>
  )
}

const CellColumnBtns = (props) => {
  const { t, handleChangePage, toggleDialogYesNo, dataItem, handleClassify } = props
  const showBtnDelete = dataItem.default ? false : true
  const is450 = useMediaQuery('(max-width:1250px)')

  return (
    <td>
      <div className='grid-btn-div'>
        {!is450 && (
          <>
            {!dataItem.default && (
              <button
                className='grid-btn-action'
                onClick={() => handleClassify && handleClassify(dataItem)}
              >
                <p>{t('documentsToRequire.grid.actions.group')}</p>
              </button>
            )}

            <button
              className='grid-btn-action'
              onClick={() =>
                handleChangePage(true, t('documentsToRequire.grid.detail'), dataItem)
              }
            >
              <p>{t('assembliesPrincipalView.grid.btns.detail')}</p>
            </button>

            {showBtnDelete && (
              <i style={{ cursor: 'pointer' }}
                className="k-icon k-i-delete k-i-trash"
                onClick={() => toggleDialogYesNo(dataItem, true)}>
              </i>
            )}
          </>
        )}
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
        {is450 && (
          <div className='grid-btn-arrow-mobile' onClick={() => handleChangePage(true, t('documentsToRequire.grid.detail'), dataItem)}>
            <img alt='assemblies-arrow' src={ArrowBtnMobile} />
          </div>
        )}

        {
          is450 && showBtnDelete && (
            <div>
              <i style={{ cursor: 'pointer' }}
                className="k-icon k-i-delete k-i-trash"
                onClick={() => toggleDialogYesNo(dataItem, true)}>
              </i>
            </div>
          )
        }
      </div>
    </td >
  )
}

const DocumentsToRequireView = (props) => {
  const {
    documents,
    loading,
    showLoadingRequesting,
    toggleLoadingRequesting,
    toggleErrorRequesting,
    showCompletedRequesting,
    toggleCompletedRequesting,
    showErrorRequesting,
    toggleErrorRequestingFalse,
    messageError,
    personTypes,
    goBackRoute,
    token,
    language,
    shouldReopenClassifyModal
  } = props
  const { t } = useTranslation()

  const [dataUserFiltered, setDataUserFiltered] = useState([])
  const [selectedValueFilter, setSelectedValue] = useState(null)
  const [searchValue, setSearchValue] = useState('')
  const [selectedUser, setSelectedUser] = useState({})
  const [showDetails, setShowDetails] = useState(false)
  const [nameComponentUser, setNameComponentUser] = useState('')
  const [titleHeader, setTitleHeader] = useState(t('documentsToRequire.titleHeader'))

  const [dataItemUser, setDataItemUser] = useState({})
  const [showDialogYesNo, setShowDialogYesNo] = useState(false)

  // Estados para modal de clasificación
  const [showClassifyModal, setShowClassifyModal] = useState(false)
  const [documentToClassify, setDocumentToClassify] = useState(null)
  const [shouldReturnToList, setShouldReturnToList] = useState(false)

  const clientId = props?.user?.userMetaData?.userMifirma?.clientId || 0

  const is1500 = useMediaQuery('(max-width:1500px)')
  const is1360 = useMediaQuery('(max-width:1360px)')
  const is1200 = useMediaQuery('(max-width:1200px)')
  const is1000 = useMediaQuery('(max-width:1000px)')
  const is820 = useMediaQuery('(max-width:820px)')
  const is650 = useMediaQuery('(max-width:650px)')
  const is560 = useMediaQuery('(max-width:560px)')
  const is450 = useMediaQuery('(max-width:450px)')

  const DIGITAL_LIBRARY_ALLOWED_ROLES = [
    process.env.REACT_APP_ADMIN,
    process.env.REACT_APP_ROLE_HIBOUDIGITAL_CONTRACT_ADMIN,
    process.env.REACT_APP_ROLE_HIBOUDIGITAL_CONTRACT_LAWYER,
    process.env.REACT_APP_ROLE_HIBOUDIGITAL_CONTRACT_LAWYER_AUTH
  ]

  const canCreateGroups = useMemo(() => {
    const roles = props.user?.userMetaData?.userRoles || []

    return roles.some(r =>
      DIGITAL_LIBRARY_ALLOWED_ROLES.includes(r?.role?.key)
    )
  }, [props.user])

  /**
   * @function handleClassify
   * Abre el modal de clasificación para el documento seleccionado
   * @param {Object} dataItem - Documento a clasificar
   * @returns {void}
   */
  const handleClassify = (dataItem) => {
    setDocumentToClassify(dataItem)
    setShowClassifyModal(true)
  }

  /**
   * @function handleCloseClassifyModal
   * Cierra el modal de clasificación
   * @returns {void}
   */
  const handleCloseClassifyModal = () => {
    setShowClassifyModal(false)
    setDocumentToClassify(null)
  }

  /**
   * @function handleSaveClassification
   * Guarda la clasificación de grupos del documento
   * @param {Array} groups - Grupos seleccionados
   * @returns {void}
   */
  const handleSaveClassification = (selectedGroups) => {
    if (!documentToClassify) return

    const templateId = documentToClassify.id
    const originalGroups = documentToClassify.groups || []

    const mergedGroups = originalGroups.map(g => ({
      id: g.id,
      name: g.name,
      value: selectedGroups.some(sg => sg.id === g.id)
    }))

    const newGroups = selectedGroups.filter(
      sg => !originalGroups.some(og => og.id === sg.id)
    ).map(g => ({
      id: g.id,
      name: g.name,
      value: true
    }))

    props.classifyDocument(
      documentToClassify,
      [...mergedGroups, ...newGroups],
      templateId
    )

    handleCloseClassifyModal()
  }

  /**
   * @function handleCreateGroup
   * Crea un nuevo grupo y lo agrega a la lista disponible
   * @param {Object} newGroup - Nuevo grupo creado
   * @returns {void}
   */
  const handleCreateGroup = (newGroup) => {
    if (props.createGroup) {
      props.createGroup(newGroup)
    }
  }

  let AllHeadersColumns = (props) => <HeaderColumns {...props} t={t} />
  let CellColumnOne = (props) => <CellColumnName {...props} t={t} />
  let CellColumnTwo = (props) => <CellColumnGroup {...props} t={t} />
  let CellColumnThree = (props) => <CellColumnBtns {...props} t={t} handleChangePage={handleChangePage} toggleDialogYesNo={toggleDialogYesNo} handleClassify={handleClassify} />

  let widthCellOne = '100px'
  let widthCellTwo = '60px'
  let widthCellThree = '40px'

  if (is1500) {
    widthCellOne = '180px'
    widthCellTwo = '90px'
  }
  if (is1360) {
    widthCellOne = '140px'
    widthCellTwo = '80px'
  }
  if (is1200) {
    widthCellOne = '120px'
    widthCellTwo = '70px'
  }
  if (is1000) {
    widthCellOne = '90px'
    widthCellTwo = '60px'
  }
  if (is820) {
    widthCellOne = '65px'
    widthCellTwo = '50px'
  }
  if (is650) {
    widthCellOne = '50px'
    widthCellTwo = '40px'
  }
  if (is560) {
    widthCellOne = '180px'
    widthCellTwo = '90px'
  }
  if (is450) {
    widthCellOne = '160px'
    widthCellTwo = '80px'
  }

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  useEffect(() => {
    if (props.availableGroups && props.availableGroups.length > 0) {
      setSelectedValue(props.availableGroups[0].name)
    }
  }, [props.availableGroups])



  useEffect(() => {
    if (!showCompletedRequesting) return
    if (
      props.successContext === 'delete' ||
      props.successContext === 'create-document'
    ) {
      setShouldReturnToList(true)
    }
  }, [showCompletedRequesting, props.successContext])

  useEffect(() => {
    if (!Array.isArray(documents) || documents.length === 0) {
      setDataUserFiltered([])
      return
    }

    if (!selectedValueFilter) {
      return
    }

    setDataUserFiltered(
      filterData(documents, selectedValueFilter, searchValue)
    )
  }, [documents, selectedValueFilter, searchValue])

  const backToList = () => {
    setShowDetails(false)
    setNameComponentUser('')
    setSelectedUser({})
  }

  useEffect(() => {
    if (!shouldReturnToList) return

    const timer = setTimeout(() => {
      backToList()
      setShouldReturnToList(false)
    }, 4000)

    return () => clearTimeout(timer)
  }, [shouldReturnToList])

  const searchChange = (e) => {
    const value = e.target.value
    setSearchValue(value)
  }

  const onHandlerFilter = (e) => {
    const value = e.target.value
    setSelectedValue(value)
  }

  //DialogYesNoHLpure funtion to show o not show
  const toggleDialogYesNo = (dataItem, value) => {
    setDataItemUser(dataItem)
    setShowDialogYesNo(value)
  }

  const groupOptions = props.availableGroups || []

  const filterData = (documents, selectedGroup, valueSearch) => {
    let filtered = [...documents]

    if (selectedGroup) {
      if (selectedGroup === t('documentsToRequire.filter.noGroup')) {
        filtered = filtered.filter(doc =>
          !Array.isArray(doc.groups) ||
          doc.groups.length === 0 ||
          doc.groups.every(g => g.value === false)
        )
      } else {
        filtered = filtered.filter(doc =>
          Array.isArray(doc.groups) &&
          doc.groups.some(g => g.name === selectedGroup)
        )
      }
    }

    if (valueSearch) {
      const search = valueSearch.toLowerCase()
      filtered = filtered.filter(doc =>
        doc.name.toLowerCase().includes(search)
      )
    }

    return filtered
  }

  const deleteClientDocument = async () => {
    toggleLoadingRequesting(true)

    try {
      const clientDocument = new ClientDocument(
        process.env.REACT_APP_MIFIRMA_API
      )

      const res = await clientDocument.deleteDocumentTemplate(
        dataItemUser.id,
        props.token
      )

      toggleLoadingRequesting(false)
      toggleDialogYesNo({}, false)

      if (res?.statusCode === 200) {
        const updatedDocuments = documents.filter(
          doc => doc.id !== dataItemUser.id
        )

        toggleCompletedRequesting(
          true,
          t('documentsToRequire.documentDeletedSuccess'),
          updatedDocuments
        )
        backToList()
        return
      }

      if (res?.statusCode === 430) {
        toggleErrorRequesting(
          t('documentsToRequire.errors.cannotDeleteWithGroups'),
          4000,
          false
        )
        return
      }

      if (res?.statusCode === 425) {
        toggleErrorRequesting(
          t('documentsToRequire.errors.cannotDeleteGlobalTemplate'),
          4000,
          false
        )
        return
      }

      throw new Error(res?.message || 'Delete failed')

    } catch (error) {
      toggleLoadingRequesting(false)
      toggleErrorRequesting(
        error.message || t('documentsToRequire.errors.delete.document'),
        4000,
        false
      )
    }
  }


  const handleChangePage = (show, page, documentSelected) => {
    setShowDetails(show)
    setNameComponentUser(page)
    setSelectedUser(documentSelected)

    let title = t('documentsToRequire.titleHeader')
    if (page === t('documentsToRequire.newDocument')) title = t('documentsToRequire.addDocumentTitle')
    if (page === t('documentsToRequire.grid.detail')) title = t('documentsToRequire.documentDetailsTitle')
    setTitleHeader(title)
  }

  if (loading) return <SimpleLoading />

  return (
    <div className='standard-wrapper'>
      {
        showDetails &&
          nameComponentUser &&
          nameComponentUser !== t('documentsToRequire.grid.delete') ? (
          <DocumentsToRequireConfigurationView
            {...props}
            nameComponentUser={nameComponentUser}
            selectedUser={selectedUser}
            selectedValueFilter={selectedValueFilter}
            toggleCompletedRequesting={toggleCompletedRequesting}
            toggleLoadingRequesting={toggleLoadingRequesting}
            token={props.token}
            clientId={clientId}
            rolesBySignatureProfile={props.rolesBySignatureProfile}
            validators={props.validators}
            forceRefresh={props.forceRefresh}
            typeDocuments={props.typeDocuments}
            preferenceValue={props.preferenceValue}
            newOptions={props.newOptions}
            handleChangePage={handleChangePage}
            deleteClientDocument={deleteClientDocument}
            createClientDocument={props.createClientDocument}
            updateClientDocument={props.updateClientDocument}
            toggleDialogYesNo={toggleDialogYesNo}
            availableGroups={props.availableGroups}
            createGroup={props.createGroup}
            user={props.user}
            showLoadingRequesting={showLoadingRequesting}
            showCompletedRequesting={showCompletedRequesting}
            shouldReopenClassifyModal={shouldReopenClassifyModal}
            clearReopenClassifyModal={props.clearReopenClassifyModal}
          />
        ) : (
          <div className='documentsToRequire-principalView'>

            <div className='documentsToRequire-navbar'>
              <ButtonAddHLPure
                nameBtn={t('documentsToRequire.newDocument')}
                iconAdd
                onClickBtn={() => handleChangePage(true, t('documentsToRequire.newDocument'), {})}
              />
              <SearchBarHLPure
                placeholder={t('documentsToRequire.searchBarPlaceHolder')}
                onSearchChange={(e) => searchChange(e)}
              />
              <DropDownBtnHLPure
                optionsDropDown={groupOptions}
                valueItem='name'
                nameOption='name'
                optionsValue={selectedValueFilter}
                onDropDownChange={(e) => {
                  setSelectedValue(e.target.value)
                }}
              />
            </div>
            <div className='documentsToRequire-grid'>
              <GridSelectionHLPure
                styleGeneral={false}
                pageable={true}
                skip={0}
                take={6}
                dataGrid={dataUserFiltered}

                titleRow1={t('documentsToRequire.grid.documents')}
                headerColumnOne={AllHeadersColumns}
                cellColumnOne={CellColumnOne}
                widthColumnOne={widthCellOne}
                minResizableWidth1={widthCellOne}

                columnTwo={!is450}
                titleRow2={t('documentsToRequire.grid.group')}
                headerColumnTwo={AllHeadersColumns}
                cellColumnTwo={CellColumnTwo}
                widthColumnTwo={widthCellTwo}
                minResizableWidth2={widthCellTwo}

                columnThree={true}
                titleRow3={t('documentsToRequire.grid.actions')}
                headerColumnThree={AllHeadersColumns}
                cellColumnThree={CellColumnThree}
                widthColumnThree={widthCellThree}
                minResizableWidth3={'auto'}

                styleGrid={{ height: 'auto' }}
              />
            </div>
          </div>
        )
      }
      {showDialogYesNo && (
        <DialogSystemGLPure
          showConfirm={true}
          confirmTitle={t('documentsToRequire.dialogDeleteDocumenTitle')}
          confirmMessage={t('documentsToRequire.dialogConfirmDeleteText')}
          labelCancelConfirmation={t('documentsToRequire.dialogCancelButton')}
          labelSubmitConfirmation={t('documentsToRequire.dialogDeleteDocumentButton')}
          handleConfirmDeleteFlowClose={toggleDialogYesNo}
          handleConfirmDeleteFlowSubmit={deleteClientDocument}
        />
      )}
      <DialogSystemGLPure
        showLoadingRequesting={showLoadingRequesting}
        toggleLoadingRequesting={toggleLoadingRequesting}

        showCompletedRequesting={showCompletedRequesting}
        toggleCompletedRequesting={toggleCompletedRequesting}

        showErrorRequesting={showErrorRequesting}
        toggleErrorRequesting={toggleErrorRequestingFalse}
        messageError={messageError}
      />
      {showClassifyModal && !showLoadingRequesting && !showCompletedRequesting && (
        <DocumentsToRequireClassifyModal
          showModal
          onClose={handleCloseClassifyModal}
          onSave={handleSaveClassification}
          initialSelectedGroups={documentToClassify?.groups || []}
          availableGroups={props.availableGroups || []}
          canCreateGroups={canCreateGroups}
          onCreateGroup={handleCreateGroup}
          showLoadingRequesting={showLoadingRequesting}
          showCompletedRequesting={showCompletedRequesting}
        />
      )}
    </div>
  )
}

export default DocumentsToRequireView
